export default __webpack_public_path__ + "static/media/upload_photo.839cd3f6.svg";